export default function initAddBackToTop() {
  const backToTopButton = document.getElementById("js-back-to-top");
  backToTopButton?.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
}
